import React, {
    useRef, createContext, useEffect, useState,
} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import {
    IconButton, Box, Hidden,
} from '@material-ui/core';
import { Helmet } from 'react-helmet';
import GridItem from '../../components/Grid/GridItem';
import AdminHeader from '../../components/Header/AdminHeader';
import UserFooter from '../../components/Footer/UserFooter';
import UserSideBar from '../../components/SideBar/UserSideBar';
import Typography from '../../components/Typography/CustomTypography';
import { Role } from '../../common/Constants';
import { callApiGetInformationXPAND, clearGetInfomationData } from '../../actions/RegistrationViewer';
import { MenuIcon, BackToTop, HomeIcon } from '../../components/Icons/Icon';
import styles from '../../assets/jss/pages/userLayoutStyle';
import { GetDetailCompanyOrganizerForSideBarRequested } from '../../actions/CompanyManagementOrganizer';
import OrganizerSidebar from '../../components/SideBar/OrganizerSidebar';
import { getSettingCustomTimerctrlRequest, getSettingCustomTimerctrlClear } from '../../actions/AdminSettingCustom';

const useStyles = makeStyles(styles);

export const MainContext = createContext();

const UserLayout = (props) => {
    const {
        role,
        routes,
        eventInfo,
        children,
        fetchInfo,
        clearInfo,
        seo,
        getDetailCompanyForSideBar,
        ...rest
    } = props;
    const classes = useStyles(props);
    const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    const { shortName } = useParams();
    const location = useLocation();
    const mainPanelRef = useRef(null);
    const hiddenEventName = location.pathname.indexOf('/home') >= 0
    || location.pathname.indexOf('/register-visitor') >= 0
    || location.pathname.indexOf('/register-exhibitor') >= 0;
    const displayBackGroundImage = location.pathname.indexOf('/home') >= 0
    || location.pathname.indexOf('/register-visitor') >= 0
    || location.pathname.indexOf('/register-exhibitor') >= 0
    || location.pathname.indexOf('/exhibitor_login') >= 0
    || location.pathname.indexOf('/visitor_login') >= 0;
    const useCustomColor = location.pathname.indexOf('/register-exhibitor') >= 0
    || location.pathname.indexOf('/exhibitor_login') >= 0;

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener('scroll', () => {
            const mybutton = document.getElementById('myBtn');
            if (mybutton) {
                if (window.pageYOffset > 200) {
                    mybutton.style.display = 'flex';
                } else {
                    mybutton.style.display = 'none';
                }
            }
        });
    });

    useEffect(() => {
        fetchInfo(shortName);
        return () => {
            clearInfo();
        };
    }, [getDetailCompanyForSideBar, shortName, fetchInfo, clearInfo]);

    const handleBackHomePage = () => {
        switch (Number(role)) {
            case Role.organizer:
                history.push(`/${shortName}/organizer/home`);
                break;

            case Role.viewer:
                history.push(`/${shortName}/home`);
                break;

            default:
                break;
        }
    };
    return (
        <div className={isOpen ? classes.wrapperMobileCustomLayout : classes.wrapper}>
            {seo && (
                <Helmet>
                    <meta name="keywords" content={`${eventInfo.name}, XPAND, 展示会, セミナー, 講演会`} />
                    <meta name="description" content={`XPANDでの${eventInfo.name}は商材・サービスの展示や案内を画像・音声・動画・ライブで展示しています。`} />
                </Helmet>
            )}

            {!_.isEmpty(eventInfo) && (
                <div className={(useCustomColor || Number(role) === Role.organizer) ? classes.mainPanelOrganizer : classes.mainPanel} ref={mainPanelRef}>
                    <GridItem xs={12} md={3}>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Hidden mdUp>
                                <Box display="flex" flexDirection="column">
                                    <IconButton
                                        color="inherit"
                                        aria-label="open drawer"
                                        onClick={() => setIsOpen(!isOpen)}
                                    >
                                        <MenuIcon color={(useCustomColor || Number(role) === Role.organizer)
                                            ? '#333'
                                            : eventInfo?.settings_colors_viewer?.contents_text_color}
                                        />
                                    </IconButton>
                                    <span className={
                                        (useCustomColor || Number(role) === Role.organizer)
                                            ? classes.hiddenMenuText
                                            : classes.hiddenMenuTextCustom
                                    }
                                    >
                                        メニュー
                                    </span>
                                </Box>
                                {(eventInfo.layout_sidebar && (+role !== Role.organizer))
                                    ? (
                                        <Box display="flex" flexDirection="column">
                                            <IconButton
                                                color="inherit"
                                                aria-label="open drawer"
                                                onClick={() => handleBackHomePage()}
                                            >
                                                <HomeIcon color="#002450" />
                                            </IconButton>
                                        </Box>
                                    ) : ('')}
                            </Hidden>
                        </Box>
                    </GridItem>
                    <div
                        className={displayBackGroundImage ? classes.background : classes.displayBackGroundImage}
                        style={{ backgroundImage: eventInfo.image && displayBackGroundImage ? `url(${eventInfo.image})` : 'none' }}
                    >
                        <Box className={displayBackGroundImage ? classes.userLogo : classes.noImageLogo}>
                            {(!eventInfo.layout_sidebar || (+role === Role.organizer)) && (
                                <Typography
                                    className={classes.noImageBrand}
                                    variant="h3"
                                    color="danger"
                                    bold
                                    onClick={handleBackHomePage}
                                    style={{ display: 'flex' }}
                                >
                                    XPAND
                                    <span className={displayBackGroundImage ? classes.brand : classes.noImageBrand} style={{fontSize: '50%', position: 'absolute'}}>&reg;</span>
                                </Typography>
                            )}

                        </Box>
                        {!hiddenEventName && (
                            <AdminHeader
                                routes={routes}
                                isUser
                                displayBackGroundImage={displayBackGroundImage}
                                customColorEvent={useCustomColor ? {} : eventInfo?.settings_colors_viewer}
                            />
                        )}
                    </div>
                    <div className={(eventInfo.layout_sidebar && +role !== Role.organizer) ? '' : classes.content}>
                        {
                            Number(role) === Role.organizer && (
                                <OrganizerSidebar
                                    isOpenToggle={isOpen}
                                    handleDrawerToggle={() => setIsOpen(!isOpen)}
                                    isUser
                                    routes={routes}
                                    color="blue"
                                    locale="ja"
                                    {...rest}
                                />
                            )
                        }
                        {/* {
                            Number(role) === Role.viewer && (
                                <UserSideBar
                                    isOpenToggle={isOpen}
                                    handleDrawerToggle={() => setIsOpen(!isOpen)}
                                    isUser
                                    routes={routes}
                                    color="navy"
                                    customColorSidebar={useCustomColor ? {} : eventInfo?.settings_colors_viewer}
                                    {...rest}
                                />
                            )
                        } */}
                        <Box className={(eventInfo.layout_sidebar && (+role !== Role.organizer)) ? classes.mainContentCustomLayout : classes.mainContent}>
                            <MainContext.Provider value={mainPanelRef}>
                                <div style={{ flex: '1 0 auto', width: '100%' }}>
                                    {children}
                                </div>
                                {(eventInfo.layout_sidebar && (+role !== Role.organizer)) ? '' : <UserFooter roleNoLogin={useCustomColor} />}
                            </MainContext.Provider>
                        </Box>
                        {(eventInfo.layout_sidebar && (+role !== Role.organizer)) ? <UserFooter roleNoLogin={useCustomColor} /> : ''}
                    </div>
                </div>
            )}
            <IconButton
                id="myBtn"
                onClick={() => window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                })}
                className={classes.backToTop}
            >
                <BackToTop color="#fff" />
            </IconButton>

        </div>
    );
};

UserLayout.defaultProps = {
    routes: {},
    role: 0,
    eventInfo: {},
    children: undefined,
};

UserLayout.propTypes = {
    routes: PropTypes.oneOfType([() => null, PropTypes.object]),
    role: PropTypes.number,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    children: PropTypes.oneOfType([() => null, PropTypes.element, PropTypes.object, PropTypes.array]),
    fetchInfo: PropTypes.func.isRequired,
    clearInfo: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    eventInfo: state.registration.registrationViewer.data,
    role: state.auth.credential.data.role,
    customTimerctrl : state.adminSettingCustom.getCustomTimerctrl.data,    
});

const mapDispatchToProps = (dispatch) => ({
    fetchInfo: (event) => {
        dispatch(callApiGetInformationXPAND(event));
    },
    clearInfo: () => {
        dispatch(clearGetInfomationData());
    },
    getDetailCompanyForSideBar: () => {
        dispatch(GetDetailCompanyOrganizerForSideBarRequested());
    },
    getSettingCustomTimerctrl: (params) =>{
    	  dispatch(getSettingCustomTimerctrlRequest(params));
    },
    clearCustomTimerctrl: () =>{
    	  dispatch(getSettingCustomTimerctrlClear() );
    },    
});

export default connect(mapStateToProps, mapDispatchToProps)(UserLayout);
